/*
 * @providesModule HeaderModalStyle
 * 
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet,
} from 'react-native';


const {
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSecondary,
  tabHighlightColor,
  btnTextColorOne,
} = SkillzStyle.fullStyles;

const headerHeight = Sizes.select({
  smallPhone: 30,
  largePhone: 40,
  tablet: 48
});

export default StyleSheet.create({

  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  container: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignSelf: 'center',
    width: Sizes.select({
      phone: Sizes.screenWidth * .8, // eslint-disable-line no-magic-numbers
      tablet: Sizes.screenWidth * .6, // eslint-disable-line no-magic-numbers
    }),
    maxHeight: Sizes.screenHeight * 0.95, // eslint-disable-line no-magic-numbers
  },

  containerLandscape: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignSelf: 'center',
    width: Sizes.select({     
      phone: Sizes.screenHeight * .5, // eslint-disable-line no-magic-numbers
      tablet: Sizes.screenHeight * .4, // eslint-disable-line no-magic-numbers
    }),
    maxHeight: Sizes.screenWidth * 0.95, // eslint-disable-line no-magic-numbers
  },

  childrenContainer: {
    backgroundColor: 'white',
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    overflow: 'hidden',
  },

  header: {
    justifyContent: 'center',
    alignSelf: 'stretch',
    backgroundColor: tabHighlightColor.color,
    height: headerHeight,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },

  title: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...Sizes.select({
      smallPhone: fontSizeH4,
      largePhone: fontSizeH3,
      tablet: fontSizeH2,
    }),
    backgroundColor: 'transparent',
    textAlign: 'center',
    padding: 7,
  },
});
